<template>
	<div class="position-relative">
		<v-btn
				class="position-absolute z-1"
				color="rgba(255,255,255,0.8)"
				elevation="0"
				fab
				:href="getEditUrl()" 
				small
				style="top: 0.5rem; right: 0.5rem;"
		>
			<v-icon color="secondary" small>mdi-pencil-outline</v-icon>
		</v-btn>
		<v-img :aspect-ratio="2" class="rounded-lg" :src="venueImage" width="360"></v-img>

		<div class="align-center d-flex justify-space-between my-2">
			<h2 class="text-h6">{{ venue.name }}</h2>
			<v-btn
					color="secondary"
					depressed
					:href="getEditUrl()"
					icon
					small
			>
				<v-icon small>mdi-pencil-outline</v-icon>
			</v-btn>
		</div>
		<div v-if="venue.description"
				 class="grey--text text--darken-1 line-clamp-2 text-body-2"
				 v-html="venue.description"></div>
		<v-text-field-details v-else error>
			Venue description is required.
		</v-text-field-details>

		<div class="align-center d-flex justify-space-between mt-6">
			<h4 class="font-weight-bold text-subtitle-1">PIN Number</h4>
			<div>
				<v-tooltip bottom color="info">
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" color="info" depressed icon small v-on="on">
							<v-icon small>mdi-help-circle-outline</v-icon>
						</v-btn>
					</template>
					<span>
            The PIN Number is the 4 digit code
            <br/>
            used to validate certain redemptions.
          </span>
				</v-tooltip>
				<v-btn
						color="secondary"
						depressed
						:href="getEditUrl()"
						icon
						small
				>
					<v-icon small>mdi-pencil-outline</v-icon>
				</v-btn>
			</div>
		</div>

		<v-divider class="mb-4 mt-2 opacity-50"></v-divider>

		<div class="grey--text text--darken-1 text-body-2">
			<div
					v-for="(num, idx) in venue.pin_number || '1234'"
					:key="idx"
					class="font-weight-bold grey lighten-3 pin-box rounded-sm"
			>
				{{ num }}
			</div>
			<v-text-field-details v-if="isPinBad" error>
				PIN reset is required
			</v-text-field-details>

		</div>

		<div class="d-flex justify-space-between mt-6">
			<h4 v-if="venueHours.length" class="font-weight-bold text-subtitle-1">
				Contact Info
			</h4>
			<v-btn
					color="secondary"
					depressed
					:href="getEditUrl()"
					icon
					small
			>
				<v-icon small>mdi-pencil-outline</v-icon>
			</v-btn>
		</div>

		<v-divider class="mb-4 mt-2 opacity-50"></v-divider>

		<div class="d-flex mb-2">
			<v-icon class="align-self-start me-2 mt-1" small>mdi-map-marker-outline</v-icon>
			<div class="grey--text text--darken-1 text-body-2">
				{{ venue.address }}
			</div>
		</div>
		<div class="align-center d-flex">
			<v-icon class="align-self-start me-2 mt-1" small>mdi-phone-outline</v-icon>
			<div class="grey--text text--darken-1 text-body-2">
				{{ venue.phone }}
			</div>
		</div>

		<v-text-field-details v-if="!hasAddressComponents" error>
			Incomplete address, click pencil to edit.
		</v-text-field-details>

		<div
				v-if="venue.latitude && venue.longitude && 1 === 2"
				class="w-100"
				style="height: 150px"
		>
			<iframe
					allowfullscreen
					frameborder="0"
					height="150"
					:src="`https://www.google.com/maps/embed/v1/view?key=${$publicMapKey}&center=${venue.latitude},${venue.longitude}&zoom=12`"
					style="border: 0"
					width="100%"
			></iframe>
		</div>

		<template v-if="3 === 2">

			<div class="align-center d-flex justify-space-between mt-6">
				<h4 v-if="venueHours.length" class="font-weight-bold text-subtitle-1">Hours</h4>
				<v-btn
						color="secondary"
						depressed
						:href="getEditUrl()"
						icon
						small
				>
					<v-icon small>mdi-pencil-outline</v-icon>
				</v-btn>
			</div>

			<v-divider class="mb-4 mt-2 opacity-50"></v-divider>

			<div
					v-for="(day, idx) in venueHours"
					v-if="venueHours.length"
					:key="`hours-${idx}`"
					dense
			>
				<div class="d-flex justify-space-between">
					<span class="font-weight-bold grey--text text--darken-1 text-subtitle-2">
						{{ day.name }}
					</span>
					<span class="grey--text text-body-2">{{ day.hours }}</span>
				</div>
				<v-divider v-if="idx < venueHours.length - 1" class="my-1 opacity-30"></v-divider>
			</div>

			<v-divider class="mb-4 mt-2 opacity-70"></v-divider>

		</template>
	</div>
</template>

<script>
export default {
	name: 'VenueInfo',
	components: {},
	props: {
		venue: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {};
	},
	computed: {
		hasAddressComponents() {
			return true;
			// We'll revisit this
			// return this.venue?.address_components?.length;
		},
		venueHours() {
			const { weekday_text } = this.venue?.hours || {};

			if(!weekday_text?.length) return [];

			return weekday_text.map(text => ({
				name: text.split(': ')[0],
				hours: text.split(': ')[1]
			}));
		},
		venueImage() {
			const { header: headerImage } = this.venue.images;
			return headerImage || '/images/placehold.co.png';
		},
		isPinBad() {
			return !this.venue.pin_number || this.venue.pin_number === '1234';
		}
	},
	methods: {
		getEditUrl() {
			return `/merchant-portal/${this.venue.id}/settings/main/edit-merchant`;
		}
	}
};
</script>

<style lang="scss" scoped>
.pin-box {
	display: inline-flex;
	margin-right: 0.5rem;
	height: 30px;
	width: 24px;
	text-align: center;
	align-items: center;
	justify-content: center;

	&--error {
		background-color: rgba(210, 106, 92, 0.1);
		color: var(--v-error-base);
		outline: solid 1px var(--v-error-lighten2);
	}
}
</style>
